export class TipoDoctoRef {

    public tipos =
        [
            { nome: 'TIPO_DOCTO_REF_1', codigo: '1', descricao: '1-NF-e/NFC-e' },
            { nome: 'TIPO_DOCTO_REF_2', codigo: '2', descricao: '2-NF Avulsa' },
            { nome: 'TIPO_DOCTO_REF_3', codigo: '3', descricao: '3-NF Produtor Rural' },
            { nome: 'TIPO_DOCTO_REF_4', codigo: '4', descricao: '4-ECF (Cupom Fiscal - 2D)' },
            { nome: 'TIPO_DOCTO_REF_5', codigo: '5', descricao: '5-Cupom Fiscal (Maq.Registradora - 2B)' },
            { nome: 'TIPO_DOCTO_REF_6', codigo: '6', descricao: '6-Cupom Fiscal (PDV - 2C)' },
            { nome: 'TIPO_DOCTO_REF_7', codigo: '7', descricao: '7-CT-e' },
        ]
}
